import { m8API } from 'services/production/m8';
import { DownloadBillReportService } from 'types/services';
import { downloadBlob } from 'utils/downloadBlob';

export const downloadBillReport: DownloadBillReportService = async ({
  billId,
  clientId,
}) => {
  const reportBlob = await m8API.admin.getReport({
    idDebit: billId,
    idUser: clientId,
  });

  downloadBlob(reportBlob);
};
